import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Search Component
 * A reusable search input component with two-way binding and callback support
 */
@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
})
export class SearchComponent {
    @Input() placeholder: string = 'Search...';
    @Input() value: string = '';
    @Output() valueChange = new EventEmitter<string>();
    @Output() inputChange = new EventEmitter<string>();
    @Output() callback = new EventEmitter<string>();

    /**
     * Handle input change event
     * @param event - Input event
     */
    onInputChange(event: Event): void {
        const inputValue = (event.target as HTMLInputElement).value;
        this.value = inputValue;
        this.valueChange.emit(inputValue);
        this.inputChange.emit(inputValue);
    }

    /**
     * Handle Enter key press for immediate search
     * @param event - Keyboard event
     */
    onKeyPress(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.callback.emit(this.value);
        }
    }
}
